<template>
  <section class="Page" :style="{ height: pageHeight }">
    <Header
      class="Page__header"
      v-bind="accountHeader"
      :showServiceMenu="false"
    />
    <main ref="mainRef" class="Page__main">
      <GlobalNavigation
        class="Page__globalNavigation"
        :globalMenuItems="globalMenuItems"
      />
      <!-- 更新ボタン -->
      <ScrollBox class="Page__scrollBox" always>
        <div ref="groupDivRef" class="Page__groupDiv">
          <section class="Page__groupSection">
            <Breadcrumb class="Page__breadcrumb" :breadcrumb="breadcrumb" />
            <header class="Page__mainHeader">
              <Heading
                type="quaternary"
                level="1"
                :heading="groupName"
                class="Page__heading"
              />
            </header>

            <GroupManagement
              :groupId="groupId"
              :isDefaultGroup="isDefault"
            ></GroupManagement>
          </section>
        </div>
      </ScrollBox>
    </main>
  </section>
</template>
<script lang="ts">
export default {
  name: 'AdminContractGroup',
};
</script>

<script lang="ts" setup>
import Heading from '@spectee/components/Atoms/Heading/index.vue';
import Breadcrumb from '@spectee/components/Molecules/Breadcrumb/index.vue';
import GlobalNavigation from '@spectee/components/Organisms/GlobalNavigation/index.vue';
import { globalMenuItems } from '../../../data/SideMenuItems';
import Header from '@spectee/components/Organisms/Header/index.vue';
import GroupManagement from '@spectee/components/Organisms/GroupManagement/index.vue';
import { computed, ref, onMounted, onUnmounted, nextTick } from 'vue';
import ScrollBox from '@spectee/components/Atoms/ScrollBox/index.vue';
import { useWindowHeight } from '@spectee/composables/useWindowHeight';
import messages from '../../../messages.json';

const { pageHeight } = useWindowHeight();

const accountHeader = ref({
  color: 'blue',
});

const unicodeSpace = '\u00A0\u00A0';

const state = window.history.state;
const groupId: string = state.groupId;
const groupName: string = state.groupName;
const isDefault: boolean = state.isDefault;

const breadcrumb = computed(() => {
  return [
    { link: '/', text: messages.heading.home },
    {
      link: '/groups',
      text: `${messages.heading.groupManagement} ${unicodeSpace}`,
    },
    {
      text: ` ${unicodeSpace} ${groupName}   `,
    },
  ];
});

const mainRef = ref<HTMLElement | null>(null);
const groupDivRef = ref<HTMLElement | null>(null);

const setContentsHeight = async () => {
  if (mainRef.value && groupDivRef.value) {
    groupDivRef.value.style.height = '';

    await nextTick();

    const mainStyle = getComputedStyle(mainRef.value);
    const mainHeight = parseFloat(mainStyle.height);
    const headerHeight = 24;
    const groupContentHeight = mainHeight - headerHeight;

    const groupTableVisibleHeight = 500;
    const height =
      groupContentHeight > groupTableVisibleHeight
        ? groupContentHeight
        : groupTableVisibleHeight;
    groupDivRef.value.style.height = `${height}px`;
  }
};

onMounted(() => {
  setContentsHeight();
  window.addEventListener('resize', setContentsHeight);
});

onUnmounted(() => {
  window.removeEventListener('resize', setContentsHeight);
});
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_pageForward.scss' as *;

.Page {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100vh;
  min-height: 0;
  min-width: $service-min-width;

  &__mainHeader {
    display: flex;
    align-items: center;
  }

  &__link {
    display: flex;
  }

  & &__icon {
    width: $service-unit * 6;
    height: $service-unit * 6;
    margin-left: $service-unit * 2;
    color: $color-gray-80;
  }

  &__groupDiv {
    flex: 1;
    overflow: auto;
  }

  &__groupSection {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__button {
    text-align: center;
  }

  & &__header {
    position: unset;
  }
  & &__main {
    position: relative;
    display: flex;
    height: 100%;
    overflow: hidden;
    padding: 0;
    flex-grow: 1;
  }

  &__scrollBox {
    flex: 1;
  }

  &__breadcrumb,
  &__heading {
    padding: $service-unit * 4 $service-unit * 8 0;
  }

  @media (max-width: 425px) {
    &__breadcrumb {
      font-size: $service-font-size-pp;
    }
  }

  @media (min-width: 768px) {
    & &__globalNavigation {
      position: unset;
    }
  }

  @media (max-width: 767px) {
    &__scrollBox {
      flex: 1;
      margin-left: $service-unit * 6;
      box-shadow: $service-shadow-mp;
    }
  }
}
</style>
